<h2 mat-dialog-title>{{ isTask ? 'Task Details' : 'Todo Details' }}</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <section class="summary-card">
    <div>
      <p class="eyebrow">{{ isTask ? (data.item.projectName || 'Assigned Task') : 'Private Todo' }}</p>
      <h3>{{ data.item.title }}</h3>
      <p>{{ isTask ? 'Assigned task from projects' : 'Visible only to you' }}</p>
    </div>
    <div class="summary-meta">
      <span>Status: {{ data.item.status }}</span>
      <span>Priority: {{ data.item.priority }}</span>
      <span>Updated: {{ data.item.updatedAt | date:'short' }}</span>
    </div>
  </section>

  <section class="form-card">
    <div class="form-grid">
      <mat-form-field appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput formControlName="title">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select formControlName="status">
          <mat-option value="Pending">Pending</mat-option>
          <mat-option value="In Progress">In Progress</mat-option>
          <mat-option value="Blocked">Blocked</mat-option>
          <mat-option value="Done">Done</mat-option>
          <mat-option value="Completed">Completed</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Priority</mat-label>
        <mat-select formControlName="priority">
          <mat-option value="Low">Low</mat-option>
          <mat-option value="Medium">Medium</mat-option>
          <mat-option value="High">High</mat-option>
          <mat-option value="Urgent">Urgent</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Due Date</mat-label>
        <input matInput type="date" formControlName="dueDate">
      </mat-form-field>

      <mat-form-field appearance="outline" *ngIf="isTask">
        <mat-label>Progress %</mat-label>
        <input matInput type="number" min="0" max="100" formControlName="progressPercent">
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput rows="5" formControlName="description"></textarea>
    </mat-form-field>
  </section>

  <section class="comments-card">
    <div class="section-head">
      <h3>Comments</h3>
      <span>{{ comments.length }} updates</span>
    </div>

    <div class="comment-list" *ngIf="comments.length; else emptyComments">
      <div class="comment-item" *ngFor="let comment of comments">
        <div class="comment-meta">
          <strong>{{ comment.createdByStaffName || comment.createdByName || 'User' }}</strong>
          <span>{{ comment.createdAt | date:'short' }}</span>
        </div>
        <p>{{ comment.comment }}</p>
        <div class="reply-list" *ngIf="comment.replies?.length">
          <div class="reply-item" *ngFor="let reply of comment.replies">
            <div class="comment-meta">
              <strong>{{ reply.createdByStaffName || reply.createdByName || 'User' }}</strong>
              <span>{{ reply.createdAt | date:'short' }}</span>
            </div>
            <p>{{ reply.comment }}</p>
          </div>
        </div>
      </div>
    </div>

    <ng-template #emptyComments>
      <p class="empty-text">No comments yet.</p>
    </ng-template>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Add comment</mat-label>
      <textarea matInput rows="3" [(ngModel)]="commentText"></textarea>
    </mat-form-field>
    <div class="comment-actions">
      <button mat-flat-button color="primary" (click)="addComment()" [disabled]="commentSaving">
        {{ commentSaving ? 'Posting...' : 'Post Comment' }}
      </button>
    </div>
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="dialogRef.close()">Close</button>
  <button mat-flat-button color="primary" type="button" (click)="save()" [disabled]="saving">
    {{ saving ? 'Saving...' : 'Save Changes' }}
  </button>
</mat-dialog-actions>
